import { HttpClient, RequestParams } from "./base/BaseHttpClient";
import { BusinessGoalDataDto } from "./contracts/models";

export class BusinessGoalDataApi<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags BusinessGoalData
   * @name List
   * @request GET:/api/business-goal-data/{projectId}
   * @response `200` `(BusinessGoalDataDto)[]` OK
   */
  list = (projectId: string, params: RequestParams = {}) =>
    this.http
      .request<BusinessGoalDataDto[], any>({
        path: `/api/business-goal-data/${projectId}`,
        method: "GET",
        credentials: "include",
        format: "json",
        ...params,
      })
      .then((m) => m.data);
}
